import { createFileRoute } from "@tanstack/react-router"

export const Route = createFileRoute("/(admin)/admin/")({
  component: RouteComponent,
})

function RouteComponent() {
  return (
    <div className="flex flex-1 flex-col gap-4 p-4">
      <div className="flex items-center justify-between">
        <h1 className="text-3xl font-bold">Admin Dashboard</h1>
      </div>
    </div>
  )
}
